import React from 'react';
import { Link } from 'react-router-dom';
import { footerNavigation } from '../lib/data';
import { LinkedInIcon } from './Icons';
import { AnalyticsOptOut } from './AnalyticsOptOut';


export const Footer: React.FC<{ waitlistMode?: boolean }> = ({ waitlistMode = false }) => {
  const renderLink = (item: { name: string; href: string }) => {
    if (item.href.startsWith('/product/')) {
      return (
        <Link to={item.href} className="text-sm/6 text-gray-600 hover:text-gray-900 transition-colors">
          {item.name}
        </Link>
      );
    }
    return (
      <a href={item.href} className="text-sm/6 text-gray-600 hover:text-gray-900 transition-colors">
        {item.name}
      </a>
    );
  };

  return (
    <footer className="relative mx-auto mt-32 max-w-7xl px-6 lg:px-8">
      <div className="border-t border-gray-900/10 py-16 sm:py-24 lg:py-32">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-4">
            <img
              alt="BrandedMark Logo"
              src="/img/logo-compact.png"
              className="h-12 w-auto"
            />
            <p className="text-sm text-gray-600 max-w-sm">
              The post-purchase platform for product brands. Connect with customers from unboxing to advocacy.
            </p>
          </div>
          {!waitlistMode && (
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm/6 font-semibold text-gray-900">Product</h3>
                <ul role="list" className="mt-6 space-y-4">
                  {footerNavigation.product.map((item) => (
                    <li key={item.name}>{renderLink(item)}</li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm/6 font-semibold text-gray-900">Company</h3>
                <ul role="list" className="mt-6 space-y-4">
                  {footerNavigation.company.map((item) => (
                    <li key={item.name}>{renderLink(item)}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm/6 font-semibold text-gray-900">Resources</h3>
                <ul role="list" className="mt-6 space-y-4">
                  {footerNavigation.resources.map((item) => (
                    <li key={item.name}>{renderLink(item)}</li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm/6 font-semibold text-gray-900">Legal</h3>
                <ul role="list" className="mt-6 space-y-4">
                  {footerNavigation.legal.map((item) => (
                    <li key={item.name}>{renderLink(item)}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          )}
        </div>
        <div className="mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 lg:mt-24">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center space-x-4">
              <p className="text-xs text-gray-500">
                &copy; {new Date().getFullYear()} BrandedMark. All rights reserved.
              </p>
              <AnalyticsOptOut />
              <a
                href="https://www.linkedin.com/company/brandedmark/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <span className="sr-only">LinkedIn</span>
                <LinkedInIcon className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
